import { motion } from "framer-motion";
import { ArrowLeft, Sparkles } from "lucide-react";

const LABELS = {
  all: "All",
  anxiety: "Anxiety",
  comfort: "Comfort",
  courage: "Courage",
  faith: "Faith",
  faithfulness: "Faithfulness",
  forgiveness: "Forgiveness",
  gratitude: "Gratitude",
  guidance: "Guidance",
  healing: "Healing",
  hope: "Hope",
  humility: "Humility",
  identity: "Identity",
  joy: "Joy",
  kindness: "Kindness",
  love: "Love",
  patience: "Patience",
  peace: "Peace",
  perseverance: "Perseverance",
  prayer: "Prayer",
  purpose: "Purpose",
  strength: "Strength",
  surrender: "Surrender",
  wisdom: "Wisdom",
  worship: "Worship",
};

export const CategoryMenu = ({
  categories,
  counts,
  totalVerses,
  active,
  onSelect,
  onClose,
}) => {
  const list = [{ id: "all", count: totalVerses }, ...categories.map((c) => ({ id: c, count: counts?.[c] ?? 0 }))];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="absolute inset-0 z-30 bg-[#F5F3ED] overflow-y-auto"
      data-testid="category-menu"
    >
      <div className="paper-grain absolute inset-0 pointer-events-none" />

      {/* Header */}
      <div className="relative z-10 flex items-center justify-between px-6 pt-6 pb-2">
        <button
          onClick={onClose}
          data-testid="category-menu-back"
          aria-label="Back"
          className="rounded-full p-2 -ml-2 text-[#4A5D4E] hover:bg-[#EAE6DF] transition-colors"
        >
          <ArrowLeft className="w-5 h-5" strokeWidth={1.5} />
        </button>
        <span className="font-ui text-[10px] md:text-xs uppercase tracking-[0.4em] text-[#96918A]">
          Categories
        </span>
        <span className="w-9" />
      </div>

      <div className="relative z-10 px-6 pb-16">
        <p className="font-serif-verse italic text-center text-sm text-[#4A5D4E] mt-4 mb-8">
          Find the words for where you are tonight.
        </p>

        <ul
          className="max-w-2xl mx-auto grid grid-cols-2 sm:grid-cols-3 gap-3"
          data-testid="category-grid"
        >
          {list.map((opt) => {
            const isActive = active === opt.id;
            return (
              <motion.li
                key={opt.id}
                whileTap={{ scale: 0.96 }}
              >
                <button
                  onClick={() => onSelect(opt.id)}
                  data-testid={`category-tile-${opt.id}`}
                  className={[
                    "w-full text-left rounded-xl border px-4 py-4 transition-colors duration-300",
                    isActive
                      ? "bg-[#4A5D4E] text-[#F5F3ED] border-[#4A5D4E]"
                      : "bg-[#F5F3ED]/80 backdrop-blur-sm text-[#2C2A28] border-[#E5E1D8] hover:bg-[#EAE6DF]/70",
                  ].join(" ")}
                >
                  <div className="flex items-start justify-between gap-2">
                    <span className="font-serif-verse text-xl leading-tight font-medium text-[#0A0604]" style={isActive ? { color: "#F5F3ED" } : undefined}>
                      {LABELS[opt.id] || opt.id}
                    </span>
                    {isActive && (
                      <Sparkles className="w-3 h-3 mt-1.5 shrink-0" strokeWidth={1.5} />
                    )}
                  </div>
                  <span
                    className={[
                      "mt-2 block font-ui text-[10px] uppercase tracking-[0.2em]",
                      isActive ? "text-[#F5F3ED]/70" : "text-[#96918A]",
                    ].join(" ")}
                  >
                    {opt.count} {opt.count === 1 ? "verse" : "verses"}
                  </span>
                </button>
              </motion.li>
            );
          })}
        </ul>
      </div>
    </motion.div>
  );
};
